import { createFileRoute } from '@tanstack/react-router'
import { FacilitiesSettings } from '@/features/organizations/settings/facilities'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute(
  '/_authenticated/_organization/facilities/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: FacilitiesSettings,
})
